var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"indigo",attrs:{"loading":_vm.loading_btn,"dark":"","icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.toggleTestLanguage()}}},[_c('v-icon',[_vm._v("mdi-translate")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }